import type { ISiteConfig } from '@/contexts/SiteContext'

const config: ISiteConfig = {
  name: 'VocalRemover.Info',
  seoTitle: (title) => {
    return `${title} | ${config.name}`
  },
  sessionProviderEnabled: false,
  supportEmail: 'support@vocalremover.info',
  analytics: {
    gtmId: 'GTM-DP36KMRV',
  },
  404: {
    image: (
      <div className='mx-auto w-fit pb-3 pt-16 md:pt-40'>
        <span className='i-cus--cr-404 size-[340px]' />
      </div>
    ),
    errorText: (
      <p className='text-f-text-invert pb-5 text-center text-7xl font-bold md:text-[64px] md:leading-[80px]'>
        404
      </p>
    ),
    message: (
      <p className='text-f-text-invert text-center text-base font-normal md:text-lg'>
        Sorry, The Page Not Found.
      </p>
    ),
  },
  500: {
    image: (
      <div className='mx-auto w-fit pb-3 pt-16 md:pt-40'>
        <span className='i-cus--cr-500 size-[340px]' />
      </div>
    ),
    errorText: (
      <p className='text-f-text-invert pb-5 text-center text-7xl font-bold md:text-[64px] md:leading-[80px]'>
        500
      </p>
    ),
    message: (
      <p className='text-f-text-invert text-center text-base font-normal md:text-lg'>
        Sorry, Internal Server Error.
      </p>
    ),
  },
}

export default config
